export const Logo = () => (
  <svg
    width="156"
    height="45"
    viewBox="0 0 156 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      opacity="0.14"
      cx="23.3777"
      cy="23.0926"
      r="21.0926"
      fill="url(#paint0_linear_22_26737)"
    />
    <path
      d="M38.2821 29.5699V16.1751C38.2821 14.0664 36.6027 12.3569 34.531 12.3569C32.4592 12.3569 30.7798 14.0664 30.7798 16.1751V25.2835C31.1341 24.9408 31.604 24.6562 32.0666 24.817C32.3133 24.9028 32.5332 25.069 32.6338 25.3619C32.7929 25.8254 32.5408 26.3146 32.3154 26.7487L31.2769 28.7485C31.228 28.8424 31.1669 28.9292 31.0952 29.0065C30.8926 29.2245 30.7798 29.5131 30.7798 29.8132V30.4966C30.7798 32.0935 32.0516 33.3881 33.6205 33.3881H34.531C36.6027 33.3881 38.2821 31.6786 38.2821 29.5699Z"
      fill="#9FF9E8"
    />
    <path
      d="M24.7528 29.6986V16.0468C24.7528 13.9411 23.0458 12.2341 20.9401 12.2341C18.8344 12.2341 17.1274 13.9411 17.1274 16.0468V25.3119C17.4874 24.9653 17.968 24.6763 18.4396 24.8415C18.6923 24.93 18.9168 25.1016 19.0163 25.4044C19.1684 25.8674 18.9193 26.3514 18.6938 26.7835L17.6327 28.8173C17.5831 28.9124 17.5208 29.0004 17.4476 29.0789C17.2419 29.2993 17.1274 29.5895 17.1274 29.891V30.578C17.1274 32.198 18.4407 33.5113 20.0607 33.5113H20.9401C23.0458 33.5113 24.7528 31.8043 24.7528 29.6986Z"
      fill="#849EFE"
    />
    <path
      d="M37.9077 20.8459C39.4117 19.342 41.8408 19.3327 43.3333 20.8252C44.8258 22.3178 44.8165 24.7469 43.3126 26.2508L37.055 32.5084C35.551 34.0124 33.1219 34.0216 31.6294 32.5291C30.1369 31.0366 30.1462 28.6075 31.6501 27.1036L37.9077 20.8459Z"
      fill="#10EAED"
    />
    <path
      d="M18.2853 13.3849C19.7716 11.8985 22.1815 11.8985 23.6679 13.3849C25.1542 14.8712 25.1542 17.2811 23.6678 18.7675L10.074 32.3613C8.58764 33.8477 6.17778 33.8477 4.69142 32.3613C3.20506 30.875 3.20506 28.4651 4.69142 26.9787L18.2853 13.3849Z"
      fill="url(#paint1_linear_22_26737)"
    />
    <g filter="url(#filter0_bd_22_26737)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8665 13.7449C17.4019 14.3766 17.1274 15.1569 17.1274 16.0012V25.27C17.1346 25.2631 17.1417 25.2563 17.149 25.2495L23.652 18.7446C24.3075 18.0889 24.6744 17.2538 24.7528 16.3973V16.0012C24.7528 15.5794 24.6843 15.1736 24.5578 14.7942C24.3748 14.2671 24.0729 13.7722 23.652 13.3511C22.1631 11.8618 19.749 11.8618 18.2601 13.3511L17.8665 13.7449Z"
        fill="url(#paint2_linear_22_26737)"
      />
    </g>
    <path
      d="M31.7023 13.5258C33.2307 11.9973 35.7088 11.9973 37.2372 13.5258C38.7656 15.0542 38.7656 17.5323 37.2372 19.0607L23.5736 32.7242C22.0452 34.2527 19.5671 34.2527 18.0387 32.7242C16.5103 31.1958 16.5103 28.7177 18.0387 27.1893L31.7023 13.5258Z"
      fill="url(#paint3_linear_22_26737)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.9726 32.344C24.4627 31.6878 24.7529 30.8734 24.7529 29.9913V20.4753C24.7456 20.4824 24.7382 20.4894 24.7308 20.4964L18.0179 27.1854C17.3412 27.8597 16.9625 28.7184 16.8816 29.5991V29.9913C16.8816 30.535 16.9918 31.0528 17.1912 31.5239C17.3825 31.9623 17.6581 32.373 18.0179 32.7315C19.5549 34.263 22.0468 34.263 23.5837 32.7315L23.9726 32.344Z"
      fill="url(#paint4_linear_22_26737)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.5181 32.1105C37.9984 31.4723 38.2822 30.6838 38.2822 29.8306V20.4755C38.2748 20.4824 38.2674 20.4894 38.2599 20.4963L31.5472 27.0624C30.8705 27.7243 30.4918 28.5672 30.4109 29.4318V29.8306C30.4109 30.2635 30.484 30.6798 30.6187 31.0682C30.8082 31.5935 31.1177 32.0866 31.5472 32.5067C33.0842 34.0101 35.5761 34.0101 37.113 32.5067L37.5181 32.1105Z"
      fill="url(#paint5_linear_22_26737)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.396 13.9079C30.931 14.547 30.6567 15.3338 30.6567 16.1847V25.6387C30.664 25.6317 30.6713 25.6248 30.6786 25.6178L37.2865 18.9902C37.9526 18.3222 38.3255 17.4713 38.4051 16.5987V16.1847C38.4051 15.8178 38.3541 15.4628 38.2588 15.1265C38.0808 14.5293 37.7568 13.9666 37.2865 13.495C35.7736 11.9776 33.3206 11.9776 31.8077 13.495L31.396 13.9079Z"
      fill="url(#paint6_linear_22_26737)"
    />
    <path
      d="M70.3 18.896C71.1926 18.896 72.0021 19.0518 72.7287 19.3635C73.476 19.6751 74.1091 20.1218 74.6281 20.7035C75.147 21.2852 75.5518 21.9812 75.8424 22.7915C76.133 23.581 76.2783 24.4744 76.2783 25.4716V35.1637H72.7598V26.0014C72.7598 24.7964 72.4692 23.8511 71.888 23.1655C71.3067 22.4799 70.4868 22.1371 69.4281 22.1371C68.4317 22.1371 67.6325 22.4487 67.0305 23.072C66.4285 23.6953 66.0757 24.4848 65.9719 25.4405V25.534V35.1637H62.4533V26.0014C62.4533 24.7964 62.1523 23.8511 61.5504 23.1655C60.9691 22.4799 60.2011 22.1371 59.2462 22.1371C58.1252 22.1371 57.2326 22.511 56.5684 23.259C55.9249 23.9861 55.6031 24.9107 55.6031 26.0326V35.1637H52.1157V19.1765H55.4163V21.2956C55.8314 20.5892 56.4023 20.0179 57.1288 19.5816C57.8761 19.1245 58.8414 18.896 60.0246 18.896C61.1456 18.896 62.142 19.1453 63.0138 19.6439C63.8857 20.1426 64.5811 20.8593 65.1 21.7943C65.5775 20.9632 66.2417 20.2776 67.0928 19.7374C67.9647 19.1765 69.0337 18.896 70.3 18.896Z"
      fill="#1A3842"
    />
    <path
      d="M86.4496 18.896C88.5254 18.896 90.103 19.4362 91.1825 20.5165C92.2826 21.5969 92.8327 23.1655 92.8327 25.2223V35.1637H89.3142V33.7301C88.7537 34.2703 88.1102 34.6962 87.3837 35.0079C86.6779 35.3195 85.8787 35.4753 84.9861 35.4753C83.3877 35.4753 82.1007 35.0702 81.1251 34.2599C80.1494 33.4496 79.6616 32.2966 79.6616 30.8007C79.6616 29.9489 79.8069 29.2321 80.0975 28.6504C80.4089 28.0479 80.8241 27.5596 81.343 27.1857C81.8828 26.7909 82.5055 26.5 83.2113 26.3131C83.9378 26.1261 84.7059 26.0118 85.5155 25.9703L89.3142 25.7521V25.2846C89.3142 24.2458 89.0859 23.4356 88.6292 22.8538C88.1933 22.2513 87.4771 21.9501 86.4807 21.9501C85.4843 21.9501 84.7578 22.2202 84.3011 22.7603C83.8444 23.3005 83.6161 23.9342 83.6161 24.6614L80.0975 24.5367C80.0975 23.8303 80.2428 23.1447 80.5335 22.4799C80.8241 21.7943 81.2392 21.1918 81.779 20.6724C82.3187 20.1322 82.9829 19.7063 83.7718 19.3946C84.5606 19.0622 85.4532 18.896 86.4496 18.896ZM86.0136 28.6815C85.1833 28.7231 84.4983 28.8997 83.9586 29.2113C83.4396 29.5022 83.1801 30.0112 83.1801 30.7384C83.1801 31.4032 83.3981 31.8707 83.834 32.1408C84.2907 32.4108 84.8719 32.5459 85.5777 32.5459C86.6987 32.5459 87.6017 32.2654 88.2867 31.7045C88.9925 31.1435 89.3453 30.2501 89.3453 29.0243V28.4634L86.0136 28.6815Z"
      fill="#1A3842"
    />
    <path
      d="M101.012 20.9841C101.385 20.4231 101.946 19.9349 102.693 19.5194C103.441 19.1038 104.375 18.8961 105.496 18.8961C106.409 18.8961 107.239 19.0519 107.987 19.3635C108.755 19.6544 109.409 20.0907 109.948 20.6724C110.509 21.2334 110.945 21.9294 111.256 22.7604C111.567 23.5707 111.723 24.4952 111.723 25.534V35.1637H108.205V26.0015C108.205 24.7965 107.883 23.8512 107.239 23.1656C106.617 22.4799 105.776 22.1371 104.717 22.1371C103.596 22.1371 102.693 22.5111 102.008 23.2591C101.344 23.9862 101.012 24.9108 101.012 26.0327V35.1637H97.5244V10.9492H101.012V20.9841Z"
      fill="#1A3842"
    />
    <path
      d="M121.48 18.896C123.556 18.896 125.133 19.4362 126.213 20.5165C127.313 21.5969 127.863 23.1655 127.863 25.2223V35.1637H124.344V33.7301C123.784 34.2703 123.141 34.6962 122.414 35.0079C121.708 35.3195 120.909 35.4753 120.016 35.4753C118.418 35.4753 117.131 35.0702 116.155 34.2599C115.18 33.4496 114.692 32.2966 114.692 30.8007C114.692 29.9489 114.837 29.2321 115.128 28.6504C115.439 28.0479 115.854 27.5596 116.373 27.1857C116.913 26.7909 117.536 26.5 118.242 26.3131C118.968 26.1261 119.736 26.0118 120.546 25.9703L124.344 25.7521V25.2846C124.344 24.2458 124.116 23.4356 123.659 22.8538C123.224 22.2513 122.507 21.9501 121.511 21.9501C120.515 21.9501 119.788 22.2202 119.331 22.7603C118.875 23.3005 118.646 23.9342 118.646 24.6614L115.128 24.5367C115.128 23.8303 115.273 23.1447 115.564 22.4799C115.854 21.7943 116.27 21.1918 116.809 20.6724C117.349 20.1322 118.013 19.7063 118.802 19.3946C119.591 19.0622 120.483 18.896 121.48 18.896ZM121.044 28.6815C120.214 28.7231 119.529 28.8997 118.989 29.2113C118.47 29.5022 118.21 30.0112 118.21 30.7384C118.21 31.4032 118.428 31.8707 118.864 32.1408C119.321 32.4108 119.902 32.5459 120.608 32.5459C121.729 32.5459 122.632 32.2654 123.317 31.7045C124.023 31.1435 124.376 30.2501 124.376 29.0243V28.4634L121.044 28.6815Z"
      fill="#1A3842"
    />
    <path
      d="M132.554 35.1637V10.9492H136.041V35.1637H132.554Z"
      fill="#1A3842"
    />
    <path
      d="M147.687 18.896C148.87 18.896 149.971 19.0934 150.988 19.4881C152.005 19.8621 152.877 20.4127 153.603 21.1398C154.351 21.8462 154.932 22.7188 155.347 23.7576C155.783 24.7756 156.001 25.9183 156.001 27.1857C156.001 28.453 155.783 29.5957 155.347 30.6137C154.932 31.6317 154.351 32.5043 153.603 33.2315C152.877 33.9379 152.005 34.4885 150.988 34.8832C149.971 35.2779 148.87 35.4753 147.687 35.4753C146.504 35.4753 145.404 35.2779 144.387 34.8832C143.369 34.4885 142.487 33.9379 141.74 33.2315C140.993 32.5043 140.401 31.6317 139.965 30.6137C139.55 29.5957 139.342 28.453 139.342 27.1857C139.342 25.9183 139.55 24.7756 139.965 23.7576C140.401 22.7188 140.993 21.8462 141.74 21.1398C142.487 20.4127 143.369 19.8621 144.387 19.4881C145.404 19.0934 146.504 18.896 147.687 18.896ZM147.687 21.8878C146.296 21.8878 145.144 22.3552 144.231 23.2901C143.338 24.2043 142.892 25.5028 142.892 27.1857C142.892 28.8477 143.338 30.1462 144.231 31.0812C145.144 31.9953 146.296 32.4524 147.687 32.4524C148.372 32.4524 149.005 32.3381 149.586 32.1096C150.168 31.8603 150.676 31.5175 151.112 31.0812C151.548 30.6241 151.88 30.0735 152.109 29.4295C152.358 28.7646 152.482 28.0167 152.482 27.1857C152.482 26.3546 152.358 25.6171 152.109 24.973C151.88 24.3082 151.548 23.7472 151.112 23.2901C150.676 22.8331 150.168 22.4903 149.586 22.2617C149.005 22.0124 148.372 21.8878 147.687 21.8878Z"
      fill="#1A3842"
    />
    <defs>
      <filter
        id="filter0_bd_22_26737"
        x="-146.873"
        y="-151.766"
        width="335.625"
        height="341.036"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="82" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_22_26737"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="3" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_backgroundBlur_22_26737"
          result="effect2_dropShadow_22_26737"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_22_26737"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_22_26737"
        x1="9.76732"
        y1="39.6246"
        x2="39.6247"
        y2="9.69594"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3767F8" />
        <stop offset="0.481131" stopColor="#61D2F3" />
        <stop offset="1" stopColor="#10EAED" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_22_26737"
        x1="22.969"
        y1="12.8426"
        x2="4.69804"
        y2="32.3675"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2D23D4" />
        <stop offset="0.429794" stopColor="#2E48F3" />
        <stop offset="1" stopColor="#418CFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_22_26737"
        x1="20.9401"
        y1="12.2341"
        x2="17.1255"
        y2="24.1053"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C0CCF" />
        <stop offset="1" stopColor="#344CEF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_22_26737"
        x1="33.4783"
        y1="15.9791"
        x2="21.7729"
        y2="29.0031"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49D7E9" />
        <stop offset="0.456979" stopColor="#71CEF9" />
        <stop offset="1" stopColor="#6EB4FE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_22_26737"
        x1="18.788"
        y1="26.5449"
        x2="24.891"
        y2="31.5622"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#588AFD" />
        <stop offset="0.471686" stopColor="#649EFF" />
        <stop offset="1" stopColor="#6DAFFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_22_26737"
        x1="34.3466"
        y1="33.6343"
        x2="37.6969"
        y2="20.934"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8FCC6" />
        <stop offset="0.497488" stopColor="#95F8D2" />
        <stop offset="1" stopColor="#5EF1DA" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_22_26737"
        x1="34.5309"
        y1="12.3569"
        x2="30.6356"
        y2="25.0103"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15E6E8" />
        <stop offset="0.433113" stopColor="#36E8E5" />
        <stop offset="1" stopColor="#65E8E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const PoweredByLogo = () => (
  <svg
    width="34"
    height="38"
    viewBox="0 0 34 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      opacity="0.14"
      cx="20.1521"
      cy="18.0169"
      r="10.0169"
      fill="url(#paint0_linear_371_8708)"
    />
    <path
      d="M27.2303 21.0924V14.7312C27.2303 13.7298 26.4328 12.918 25.4489 12.918C24.4651 12.918 23.6675 13.7298 23.6675 14.7312V19.0568C23.8357 18.894 24.0589 18.7589 24.2786 18.8353C24.3957 18.876 24.5002 18.9549 24.5479 19.094C24.6235 19.3141 24.5038 19.5465 24.3967 19.7526L23.9035 20.7023C23.8804 20.7469 23.8513 20.7882 23.8173 20.8248C23.7211 20.9284 23.6675 21.0655 23.6675 21.2079V21.5325C23.6675 22.2909 24.2715 22.9057 25.0166 22.9057H25.4489C26.4328 22.9057 27.2303 22.0938 27.2303 21.0924Z"
      fill="#9FF9E8"
    />
    <path
      d="M20.8053 21.1532V14.67C20.8053 13.67 19.9947 12.8594 18.9947 12.8594C17.9947 12.8594 17.1841 13.67 17.1841 14.67V19.07C17.355 18.9054 17.5833 18.7681 17.8072 18.8466C17.9272 18.8886 18.0338 18.9701 18.0811 19.1139C18.1533 19.3338 18.035 19.5637 17.928 19.7689L17.424 20.7347C17.4005 20.7799 17.3709 20.8217 17.3361 20.8589C17.2384 20.9636 17.1841 21.1015 17.1841 21.2446V21.5709C17.1841 22.3402 17.8077 22.9639 18.5771 22.9639H18.9947C19.9947 22.9639 20.8053 22.1532 20.8053 21.1532Z"
      fill="#849EFE"
    />
    <path
      d="M27.0525 16.9495C27.7667 16.2352 28.9203 16.2308 29.6291 16.9396C30.3379 17.6484 30.3335 18.802 29.6193 19.5162L26.6475 22.488C25.9333 23.2022 24.7797 23.2066 24.0709 22.4978C23.3621 21.789 23.3665 20.6354 24.0807 19.9212L27.0525 16.9495Z"
      fill="#10EAED"
    />
    <path
      d="M17.7336 13.407C18.4395 12.7011 19.5839 12.7011 20.2898 13.407C20.9957 14.1129 20.9957 15.2573 20.2898 15.9632L13.8341 22.4189C13.1282 23.1248 11.9838 23.1248 11.2779 22.4189C10.572 21.713 10.572 20.5686 11.2779 19.8627L17.7336 13.407Z"
      fill="url(#paint1_linear_371_8708)"
    />
    <g filter="url(#filter0_bd_371_8708)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5351 13.5768C17.3144 13.8769 17.1841 14.2474 17.1841 14.6484V19.0501C17.1875 19.0468 17.1909 19.0436 17.1943 19.0404L20.2826 15.9512C20.5939 15.6398 20.7682 15.2432 20.8053 14.8365V14.6484C20.8053 14.448 20.7728 14.2553 20.7127 14.0752C20.6259 13.8248 20.4825 13.5898 20.2826 13.3898C19.5755 12.6826 18.4291 12.6826 17.722 13.3898L17.5351 13.5768Z"
        fill="url(#paint2_linear_371_8708)"
      />
    </g>
    <path
      d="M24.1052 13.4744C24.831 12.7486 26.0079 12.7486 26.7337 13.4744C27.4596 14.2003 27.4596 15.3771 26.7337 16.103L20.2449 22.5918C19.519 23.3176 18.3422 23.3176 17.6163 22.5918C16.8905 21.8659 16.8905 20.6891 17.6163 19.9632L24.1052 13.4744Z"
      fill="url(#paint3_linear_371_8708)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.4346 22.4111C20.6674 22.0995 20.8052 21.7127 20.8052 21.2938V16.7747C20.8017 16.778 20.7982 16.7814 20.7947 16.7847L17.6067 19.9613C17.2854 20.2815 17.1055 20.6893 17.0671 21.1076V21.2938C17.0671 21.552 17.1194 21.7979 17.2141 22.0216C17.305 22.2298 17.4358 22.4249 17.6067 22.5951C18.3366 23.3225 19.52 23.3225 20.2499 22.5951L20.4346 22.4111Z"
      fill="url(#paint4_linear_371_8708)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.8671 22.2998C27.0952 21.9967 27.23 21.6223 27.23 21.2171V16.7743C27.2265 16.7776 27.2229 16.7809 27.2194 16.7842L24.0315 19.9025C23.7102 20.2168 23.5303 20.6171 23.4919 21.0277V21.2171C23.4919 21.4227 23.5266 21.6203 23.5906 21.8048C23.6806 22.0543 23.8275 22.2884 24.0315 22.488C24.7614 23.2019 25.9448 23.2019 26.6747 22.488L26.8671 22.2998Z"
      fill="url(#paint5_linear_371_8708)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.96 13.6545C23.7391 13.958 23.6089 14.3317 23.6089 14.7358V19.2255C23.6123 19.2222 23.6158 19.2189 23.6193 19.2156L26.7574 16.0681C27.0737 15.7509 27.2508 15.3468 27.2886 14.9324V14.7358C27.2886 14.5615 27.2643 14.393 27.2191 14.2332C27.1346 13.9496 26.9807 13.6824 26.7574 13.4584C26.0389 12.7378 24.874 12.7378 24.1555 13.4584L23.96 13.6545Z"
      fill="url(#paint6_linear_371_8708)"
    />
    <defs>
      <filter
        id="filter0_bd_371_8708"
        x="-146.816"
        y="-151.141"
        width="331.621"
        height="334.191"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="82" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_371_8708"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="3" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_backgroundBlur_371_8708"
          result="effect2_dropShadow_371_8708"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_371_8708"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_371_8708"
        x1="13.6885"
        y1="25.8679"
        x2="27.8678"
        y2="11.6548"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3767F8" />
        <stop offset="0.481131" stopColor="#61D2F3" />
        <stop offset="1" stopColor="#10EAED" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_371_8708"
        x1="19.9579"
        y1="13.1495"
        x2="11.2811"
        y2="22.4218"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2D23D4" />
        <stop offset="0.429794" stopColor="#2E48F3" />
        <stop offset="1" stopColor="#418CFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_371_8708"
        x1="18.9947"
        y1="12.8594"
        x2="17.1832"
        y2="18.497"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C0CCF" />
        <stop offset="1" stopColor="#344CEF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_371_8708"
        x1="24.9486"
        y1="14.6395"
        x2="19.3897"
        y2="20.8246"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49D7E9" />
        <stop offset="0.456979" stopColor="#71CEF9" />
        <stop offset="1" stopColor="#6EB4FE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_371_8708"
        x1="17.9724"
        y1="19.6571"
        x2="20.8708"
        y2="22.0398"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#588AFD" />
        <stop offset="0.471686" stopColor="#649EFF" />
        <stop offset="1" stopColor="#6DAFFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_371_8708"
        x1="25.3609"
        y1="23.0234"
        x2="26.952"
        y2="16.9921"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8FCC6" />
        <stop offset="0.497488" stopColor="#95F8D2" />
        <stop offset="1" stopColor="#5EF1DA" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_371_8708"
        x1="25.4487"
        y1="12.918"
        x2="23.5989"
        y2="18.927"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15E6E8" />
        <stop offset="0.433113" stopColor="#36E8E5" />
        <stop offset="1" stopColor="#65E8E2" />
      </linearGradient>
    </defs>
  </svg>
);

export const QueryIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.228 9C8.777 7.835 10.258 7 12 7C14.21 7 16 8.343 16 10C16 11.4 14.722 12.575 12.994 12.907C12.452 13.011 12 13.447 12 14M12 17H12.01M21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon stroke"
    />
  </svg>
);

export const AdminIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <path
      d="M19.4854 18.864L19.4927 18.853L19.4814 18.8463C19.1137 18.629 18.7211 18.4619 18.3034 18.345C17.8856 18.228 17.4511 18.1695 17 18.1695C16.5489 18.1695 16.1144 18.228 15.6966 18.345C15.2789 18.4619 14.8863 18.629 14.5186 18.8463L14.5073 18.853L14.5146 18.864C14.7824 19.2657 15.1339 19.5878 15.5689 19.8305C16.0042 20.0732 16.4813 20.1945 17 20.1945C17.5187 20.1945 17.9958 20.0732 18.4311 19.8305C18.8661 19.5878 19.2176 19.2657 19.4854 18.864ZM11.5296 22.0454L11.5297 22.0454L11.5287 22.0451C9.34823 21.3793 7.55047 20.0311 6.13526 17.9999C4.72003 15.9686 4.0125 13.7294 4.0125 11.282V6.55703C4.0125 6.14297 4.13252 5.77054 4.37262 5.43937C4.61286 5.108 4.9234 4.86784 5.30447 4.71871C5.3045 4.71869 5.30453 4.71868 5.30456 4.71867L11.3042 2.4688C11.3042 2.46879 11.3043 2.46878 11.3043 2.46877C11.5363 2.38591 11.7682 2.34453 12 2.34453C12.2318 2.34453 12.4637 2.38591 12.6957 2.46877C12.6957 2.46878 12.6958 2.46879 12.6958 2.4688L18.6954 4.71867C18.6955 4.71868 18.6955 4.71869 18.6955 4.71871C19.0766 4.86784 19.3871 5.108 19.6274 5.43937C19.8675 5.77054 19.9875 6.14297 19.9875 6.55703V10.8382C19.676 10.7076 19.3564 10.5891 19.0289 10.4826C18.6982 10.3752 18.3595 10.2964 18.0125 10.2462V6.58203V6.57337L18.0044 6.57033L12.0044 4.32033L12.0058 4.3165L11.9956 4.32033L5.99561 6.57033L5.9875 6.57337V6.58203V11.282C5.9875 12.0665 6.09182 12.8509 6.30042 13.6352C6.50899 14.4195 6.801 15.1662 7.17645 15.8754C7.55192 16.5846 8.00666 17.2396 8.54066 17.8403C9.07372 18.44 9.66504 18.9401 10.3146 19.3403C10.498 19.8729 10.7313 20.3723 11.0143 20.8385C11.2929 21.2974 11.6198 21.7161 11.9949 22.0945H11.7625C11.6894 22.0945 11.6118 22.0783 11.5296 22.0454ZM17 17.1945C17.4199 17.1945 17.7773 17.0474 18.0713 16.7534C18.3654 16.4593 18.5125 16.102 18.5125 15.682C18.5125 15.2621 18.3654 14.9047 18.0713 14.6107C17.7773 14.3167 17.4199 14.1695 17 14.1695C16.5801 14.1695 16.2227 14.3167 15.9287 14.6107C15.6346 14.9047 15.4875 15.2621 15.4875 15.682C15.4875 16.102 15.6346 16.4593 15.9287 16.7534C16.2227 17.0474 16.5801 17.1945 17 17.1945ZM17 22.1695C15.62 22.1695 14.444 21.6833 13.4713 20.7107C12.4987 19.738 12.0125 18.5621 12.0125 17.182C12.0125 15.802 12.4987 14.626 13.4713 13.6534C14.444 12.6807 15.62 12.1945 17 12.1945C18.38 12.1945 19.556 12.6807 20.5287 13.6534C21.5013 14.626 21.9875 15.802 21.9875 17.182C21.9875 18.5621 21.5013 19.738 20.5287 20.7107C19.556 21.6833 18.38 22.1695 17 22.1695Z"
      strokeWidth="0.025"
      className="svgicon fill stroke"
    />
  </svg>
);

export const DashboardIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <path
      d="M5.5 19.1836V19.6836H6H9H9.5V19.1836V13.6836H14.5V19.1836V19.6836H15H18H18.5V19.1836V10.1836V9.93359L18.3 9.78359L12.3 5.28359L12 5.05859L11.7 5.28359L5.7 9.78359L5.5 9.93359V10.1836V19.1836ZM4.66 9.50762L4.66042 9.50678C4.76701 9.2931 4.91128 9.12203 5.09568 8.9868L5.0957 8.98682L5.1 8.98359L11.0969 4.48593C11.241 4.38155 11.3862 4.30689 11.5331 4.25794C11.6807 4.20873 11.8356 4.18359 12 4.18359C12.1644 4.18359 12.3193 4.20873 12.4669 4.25794C12.6138 4.30689 12.759 4.38154 12.9031 4.48592L18.9 8.98359L18.9 8.98362L18.9043 8.9868C19.0888 9.1221 19.2335 9.29334 19.3408 9.50728C19.4474 9.72113 19.5 9.94457 19.5 10.1836V19.1836C19.5 19.5998 19.3578 19.9439 19.0597 20.2428C18.7607 20.5413 18.4164 20.6836 18 20.6836H13.5V15.1836V14.6836H13H11H10.5V15.1836V20.6836H6C5.58354 20.6836 5.23978 20.5413 4.94155 20.243C4.64248 19.944 4.5 19.5998 4.5 19.1836V10.1836C4.5 9.94477 4.55282 9.72148 4.66 9.50762ZM4.213 9.28359C4.35433 9.00026 4.55 8.76693 4.8 8.58359L4.213 9.28359Z"
      className="svgicon fill stroke"
    />
  </svg>
);

export const ParticipantIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24"
    viewBox="0 -960 960 960"
    width="24"
    className="side-bar-icon"
  >
    <path
      d="M40-272q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v32q0 33-23.5 56.5T600-160H120q-33 0-56.5-23.5T40-240v-32Zm800 112H738q11-18 16.5-38.5T760-240v-40q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v40q0 33-23.5 56.5T840-160ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z"
      className="svgicon fill stroke"
    />
  </svg>
);

export const StudyBuilderIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="side-bar-icon"
  >
    <path
      d="M19.0279 9.13783L19.0276 9.13778C18.7938 9.08767 18.5475 9.0501 18.2887 9.02506C18.03 9.00002 17.7671 8.9875 17.5 8.9875C17.0659 8.9875 16.64 9.02924 16.2225 9.11274C15.8053 9.19618 15.4048 9.30466 15.0209 9.43819L15.0209 9.43819L15.0205 9.43835C14.7227 9.55413 14.4817 9.54486 14.2946 9.41474C14.1073 9.2844 14.0125 9.07221 14.0125 8.775C14.0125 8.62814 14.0655 8.47639 14.1728 8.31956C14.2802 8.16269 14.3991 8.06062 14.5292 8.01176C15.0119 7.84533 15.4945 7.72052 15.9771 7.63732C16.4597 7.55412 16.9673 7.5125 17.5 7.5125C17.8328 7.5125 18.1614 7.5333 18.4859 7.5749C18.8106 7.61652 19.131 7.67063 19.4473 7.73721C19.5942 7.76987 19.721 7.85148 19.8278 7.98288C19.9344 8.11406 19.9875 8.2613 19.9875 8.425C19.9875 8.70545 19.8969 8.9095 19.7176 9.03989C19.538 9.17051 19.3087 9.20392 19.0279 9.13783ZM19.0279 14.6378L19.0276 14.6378C18.7938 14.5877 18.5475 14.5501 18.2887 14.5251C18.03 14.5 17.7671 14.4875 17.5 14.4875C17.0659 14.4875 16.6402 14.5251 16.2228 14.6002C15.8055 14.6753 15.4049 14.7796 15.0209 14.9132L15.0209 14.9132L15.0205 14.9134C14.7226 15.0292 14.4814 15.024 14.2943 14.902C14.1073 14.78 14.0125 14.5722 14.0125 14.275C14.0125 14.1281 14.0655 13.9764 14.1728 13.8196C14.2802 13.6627 14.3991 13.5606 14.5292 13.5118C15.0119 13.3453 15.4945 13.2205 15.9771 13.1373C16.4597 13.0541 16.9673 13.0125 17.5 13.0125C17.8328 13.0125 18.1614 13.0333 18.4859 13.0749C18.8106 13.1165 19.131 13.1706 19.4473 13.2372C19.5942 13.2699 19.721 13.3515 19.8278 13.4829C19.9344 13.6141 19.9875 13.7613 19.9875 13.925C19.9875 14.2054 19.8969 14.4095 19.7176 14.5399C19.538 14.6705 19.3087 14.7039 19.0279 14.6378ZM19.0279 11.8878L19.0276 11.8878C18.7938 11.8377 18.5475 11.8001 18.2887 11.7751C18.03 11.75 17.7671 11.7375 17.5 11.7375C17.0659 11.7375 16.64 11.7792 16.2225 11.8627C15.8053 11.9462 15.4048 12.0547 15.0209 12.1882L15.0209 12.1882L15.0205 12.1883C14.7227 12.3041 14.4817 12.2949 14.2946 12.1647C14.1073 12.0344 14.0125 11.8222 14.0125 11.525C14.0125 11.3781 14.0655 11.2264 14.1728 11.0696C14.2802 10.9127 14.3991 10.8106 14.5292 10.7618C15.0119 10.5953 15.4945 10.4705 15.9771 10.3873C16.4597 10.3041 16.9673 10.2625 17.5 10.2625C17.8328 10.2625 18.1614 10.2833 18.4859 10.3249C18.8106 10.3665 19.131 10.4206 19.4473 10.4872C19.5942 10.5199 19.721 10.6015 19.8278 10.7329C19.9344 10.8641 19.9875 11.0113 19.9875 11.175C19.9875 11.4554 19.8969 11.6595 19.7176 11.7899C19.538 11.9205 19.3087 11.9539 19.0279 11.8878ZM10.9946 17.0613L11.0125 17.0698V17.05V7.2H11.0247L11.0063 7.18921C10.322 6.78863 9.59593 6.48819 8.82816 6.2879C8.06047 6.08764 7.28441 5.9875 6.5 5.9875C5.89918 5.9875 5.30254 6.04591 4.71008 6.16274C4.11758 6.27957 3.54592 6.45482 2.99512 6.68849L2.9875 6.67054V6.7V16.6V16.6175L3.00405 16.6118C3.5868 16.412 4.16533 16.2622 4.73964 16.1623C5.31391 16.0624 5.9007 16.0125 6.5 16.0125C7.28239 16.0125 8.04393 16.0999 8.78463 16.2747C9.52537 16.4494 10.262 16.7116 10.9946 17.0613ZM12.9875 17.05V17.0698L13.0054 17.0613C13.738 16.7116 14.4746 16.4494 15.2154 16.2747C15.9561 16.0999 16.7176 16.0125 17.5 16.0125C18.0993 16.0125 18.6861 16.0624 19.2604 16.1623C19.8347 16.2622 20.4132 16.412 20.9959 16.6118L21.0125 16.6175V16.6V6.7H21.032L21.0049 6.68849C20.4541 6.45482 19.8824 6.27957 19.2899 6.16274C18.6975 6.04591 18.1008 5.9875 17.5 5.9875C16.7156 5.9875 15.9395 6.08764 15.1718 6.2879C14.4041 6.48819 13.678 6.78863 12.9937 7.18921L12.9875 7.17865V7.2V17.05ZM1.55517 5.21138L1.55518 5.2114L1.55578 5.21108C2.32155 4.81155 3.12059 4.51191 3.95292 4.31215C4.78528 4.11239 5.6343 4.0125 6.5 4.0125C7.46558 4.0125 8.41031 4.13736 9.33424 4.38707C10.2581 4.63677 11.1446 5.01132 11.9937 5.51077L11.987 5.52218L12.0063 5.51077C12.8554 5.01132 13.7419 4.63677 14.6658 4.38707C15.5897 4.13736 16.5344 4.0125 17.5 4.0125C18.3657 4.0125 19.2147 4.11239 20.0471 4.31215C20.8794 4.51191 21.6785 4.81155 22.4442 5.21108L22.4442 5.2111L22.4448 5.21138C22.6259 5.29367 22.7613 5.41686 22.8515 5.58102C22.9422 5.74592 22.9875 5.91885 22.9875 6.1V18.15C22.9875 18.529 22.8272 18.8166 22.5059 19.0144C22.1849 19.2119 21.8521 19.2203 21.5058 19.0389C20.8883 18.7052 20.2417 18.4465 19.5658 18.2629C18.8897 18.0793 18.2011 17.9875 17.5 17.9875C16.7489 17.9875 16.0145 18.0835 15.2968 18.2754C14.5791 18.4674 13.8947 18.7553 13.2438 19.1391C13.0614 19.2386 12.8665 19.3174 12.6591 19.3755C12.452 19.4335 12.2323 19.4625 12 19.4625C11.7677 19.4625 11.548 19.4335 11.3409 19.3755C11.1335 19.3174 10.9386 19.2386 10.7562 19.1391C10.1053 18.7553 9.42094 18.4674 8.70323 18.2754C7.9855 18.0835 7.25108 17.9875 6.5 17.9875C5.79889 17.9875 5.11029 18.0793 4.43422 18.2629C3.75832 18.4465 3.11162 18.7052 2.49413 19.039C2.14789 19.2203 1.81512 19.2119 1.49405 19.0144C1.17277 18.8166 1.0125 18.529 1.0125 18.15V6.1C1.0125 5.91885 1.05776 5.74592 1.14845 5.58102C1.23874 5.41686 1.37414 5.29367 1.55517 5.21138Z"
      strokeWidth="0.025"
      className="svgicon fill stroke"
    />
  </svg>
);

export const StudySettingsIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.675 4.317C13.249 2.561 10.751 2.561 10.325 4.317C10.049 5.452 8.749 5.99 7.753 5.382C6.209 4.442 4.443 6.209 5.383 7.752C5.5243 7.98375 5.60889 8.24559 5.62987 8.51621C5.65085 8.78683 5.60764 9.05859 5.50375 9.30935C5.39985 9.56011 5.23822 9.7828 5.032 9.95929C4.82578 10.1358 4.5808 10.2611 4.317 10.325C2.561 10.751 2.561 13.249 4.317 13.675C4.58056 13.7391 4.82529 13.8645 5.03127 14.0409C5.23726 14.2174 5.3987 14.44 5.50247 14.6906C5.60624 14.9412 5.64942 15.2128 5.62848 15.4832C5.60755 15.7537 5.5231 16.0153 5.382 16.247C4.442 17.791 6.209 19.557 7.752 18.617C7.98375 18.4757 8.24559 18.3911 8.51621 18.3701C8.78683 18.3491 9.05859 18.3924 9.30935 18.4963C9.56011 18.6001 9.7828 18.7618 9.95929 18.968C10.1358 19.1742 10.2611 19.4192 10.325 19.683C10.751 21.439 13.249 21.439 13.675 19.683C13.7391 19.4194 13.8645 19.1747 14.0409 18.9687C14.2174 18.7627 14.44 18.6013 14.6906 18.4975C14.9412 18.3938 15.2128 18.3506 15.4832 18.3715C15.7537 18.3924 16.0153 18.4769 16.247 18.618C17.791 19.558 19.557 17.791 18.617 16.248C18.4757 16.0162 18.3911 15.7544 18.3701 15.4838C18.3491 15.2132 18.3924 14.9414 18.4963 14.6907C18.6001 14.4399 18.7618 14.2172 18.968 14.0407C19.1742 13.8642 19.4192 13.7389 19.683 13.675C21.439 13.249 21.439 10.751 19.683 10.325C19.4194 10.2609 19.1747 10.1355 18.9687 9.95905C18.7627 9.78258 18.6013 9.55999 18.4975 9.30938C18.3938 9.05877 18.3506 8.78721 18.3715 8.51677C18.3924 8.24634 18.4769 7.98466 18.618 7.753C19.558 6.209 17.791 4.443 16.248 5.383C16.0162 5.5243 15.7544 5.60889 15.4838 5.62987C15.2132 5.65085 14.9414 5.60764 14.6907 5.50375C14.4399 5.39985 14.2172 5.23822 14.0407 5.032C13.8642 4.82578 13.7389 4.5808 13.675 4.317Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon stroke"
    />
    <path
      d="M14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="svgicon stroke"
    />
  </svg>
);

export const AuditTrailIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V9.414C18.9999 9.1488 18.8946 8.89449 18.707 8.707L13.293 3.293C13.1055 3.10545 12.8512 3.00006 12.586 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V16M5 21L9.879 16.121M9.879 16.121C10.1567 16.4033 10.4876 16.6279 10.8525 16.7817C11.2174 16.9355 11.6092 17.0156 12.0052 17.0173C12.4012 17.0189 12.7936 16.9421 13.1599 16.7914C13.5261 16.6406 13.8588 16.4188 14.1388 16.1388C14.4189 15.8588 14.6408 15.5262 14.7916 15.16C14.9425 14.7938 15.0193 14.4014 15.0177 14.0054C15.0162 13.6094 14.9362 13.2176 14.7825 12.8526C14.6287 12.4877 14.4043 12.1568 14.122 11.879C13.5579 11.3239 12.7973 11.0142 12.0059 11.0173C11.2145 11.0204 10.4564 11.3362 9.8967 11.8957C9.33702 12.4553 9.02111 13.2133 9.0178 14.0047C9.01448 14.7961 9.32402 15.5568 9.879 16.121Z"
      strokeWidth="2"
      strokeLinecap="round"
      className="svgicon stroke"
      strokeLinejoin="round"
    />
  </svg>
);
export const MahaloIcon = () => (
  <svg
    width="35"
    height="31"
    viewBox="0 0 52 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.14"
      d="M49.3315 25.5C49.3315 39.031 38.3625 50 24.8315 50C11.3005 50 0.331482 39.031 0.331482 25.5C0.331482 11.969 11.3005 1 24.8315 1C38.3625 1 49.3315 11.969 49.3315 25.5Z"
      fill="url(#paint0_linear_79_793)"
    />
    <path
      d="M42.1431 33.024V17.4652C42.1431 15.0159 40.1924 13.0303 37.786 13.0303C35.3796 13.0303 33.4288 15.0159 33.4288 17.4652V28.0451C33.8404 27.647 34.3862 27.3164 34.9235 27.5033C35.21 27.6029 35.4655 27.796 35.5823 28.1362C35.7671 28.6745 35.4744 29.2428 35.2125 29.747L34.0062 32.0698C33.9495 32.179 33.8785 32.2798 33.7952 32.3695C33.5599 32.6227 33.4288 32.958 33.4288 33.3065V34.1003C33.4288 35.9552 34.9061 37.4589 36.7285 37.4589H37.786C40.1924 37.4589 42.1431 35.4733 42.1431 33.024Z"
      fill="#9FF9E8"
    />
    <path
      d="M26.4289 33.174V17.3168C26.4289 14.8709 24.4462 12.8882 22.0003 12.8882C19.5545 12.8882 17.5717 14.8709 17.5717 17.3168V28.0786C17.9899 27.676 18.5481 27.3403 19.0959 27.5322C19.3894 27.635 19.6501 27.8344 19.7657 28.1861C19.9424 28.7239 19.653 29.2861 19.3912 29.7879L18.1586 32.1503C18.101 32.2608 18.0286 32.363 17.9436 32.4541C17.7046 32.7102 17.5717 33.0473 17.5717 33.3975V34.1955C17.5717 36.0772 19.0971 37.6026 20.9788 37.6026H22.0003C24.4462 37.6026 26.4289 35.6198 26.4289 33.174Z"
      fill="#849EFE"
    />
    <path
      d="M41.7084 22.8911C43.4553 21.1442 46.2768 21.1334 48.0104 22.867C49.744 24.6007 49.7333 27.4222 47.9864 29.1691L40.7178 36.4376C38.9709 38.1845 36.1494 38.1953 34.4158 36.4616C32.6822 34.728 32.6929 31.9065 34.4398 30.1596L41.7084 22.8911Z"
      fill="#10EAED"
    />
    <path
      d="M18.9161 14.2242C20.6426 12.4977 23.4418 12.4977 25.1682 14.2242C26.8947 15.9507 26.8947 18.7498 25.1682 20.4763L9.37833 36.2662C7.65186 37.9927 4.85269 37.9927 3.12622 36.2662C1.39974 34.5397 1.39974 31.7406 3.12622 30.0141L18.9161 14.2242Z"
      fill="url(#paint1_linear_79_793)"
    />
    <g filter="url(#filter0_bd_79_793)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4302 14.643C17.8906 15.3768 17.5717 16.2831 17.5717 17.2638V28.0299C17.58 28.022 17.5884 28.014 17.5967 28.0061L25.1503 20.4504C25.9117 19.6888 26.3379 18.7188 26.4289 17.724V17.2638C26.4289 16.7739 26.3493 16.3025 26.2024 15.8619C25.9899 15.2496 25.6392 14.6747 25.1503 14.1857C23.4209 12.4557 20.6168 12.4557 18.8874 14.1856L18.4302 14.643Z"
        fill="url(#paint2_linear_79_793)"
      />
    </g>
    <path
      d="M34.5009 14.3884C36.2762 12.613 39.1546 12.613 40.9299 14.3884C42.7053 16.1637 42.7053 19.0421 40.9299 20.8175L25.0591 36.6883C23.2837 38.4636 20.4053 38.4636 18.63 36.6883C16.8547 34.913 16.8547 32.0346 18.63 30.2592L34.5009 14.3884Z"
      fill="url(#paint3_linear_79_793)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.5226 36.247C26.0919 35.4847 26.429 34.5388 26.429 33.5142V22.461C26.4205 22.4691 26.4119 22.4773 26.4033 22.4854L18.606 30.255C17.82 31.0382 17.38 32.0356 17.2861 33.0587V33.5142C17.2861 34.1457 17.4142 34.7472 17.6457 35.2943C17.8679 35.8036 18.188 36.2806 18.606 36.6971C20.3912 38.476 23.2857 38.476 25.071 36.6971L25.5226 36.247Z"
      fill="url(#paint4_linear_79_793)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.2555 35.9747C41.8134 35.2334 42.143 34.3176 42.143 33.3264V22.46C42.1345 22.4681 42.1258 22.4762 42.1171 22.4842L34.32 30.1111C33.534 30.8799 33.0941 31.859 33.0001 32.8632V33.3264C33.0001 33.8293 33.085 34.3128 33.2415 34.764C33.4616 35.3741 33.8211 35.9469 34.32 36.4349C36.1052 38.1812 38.9997 38.1812 40.785 36.4349L41.2555 35.9747Z"
      fill="url(#paint5_linear_79_793)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.1444 14.8318C33.6044 15.5742 33.2858 16.4881 33.2858 17.4764V28.4577C33.2942 28.4496 33.3027 28.4415 33.3112 28.4334L40.9866 20.7351C41.7603 19.9592 42.1934 18.9709 42.2858 17.9573V17.4764C42.2858 17.0502 42.2266 16.6379 42.1159 16.2472C41.9092 15.5536 41.5328 14.9 40.9866 14.3522C39.2292 12.5896 36.38 12.5896 34.6226 14.3522L34.1444 14.8318Z"
      fill="url(#paint6_linear_79_793)"
    />
    <defs>
      <filter
        id="filter0_bd_79_793"
        x="-146.428"
        y="-151.112"
        width="336.857"
        height="343.142"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="82" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_79_793"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2" dy="3" />
        <feGaussianBlur stdDeviation="7.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_backgroundBlur_79_793"
          result="effect2_dropShadow_79_793"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_79_793"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_79_793"
        x1="9.02236"
        y1="44.7027"
        x2="43.7031"
        y2="9.93919"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3767F8" />
        <stop offset="0.481131" stopColor="#61D2F3" />
        <stop offset="1" stopColor="#10EAED" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_79_793"
        x1="24.3565"
        y1="13.5943"
        x2="3.13391"
        y2="36.2734"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2D23D4" />
        <stop offset="0.429794" stopColor="#2E48F3" />
        <stop offset="1" stopColor="#418CFD" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_79_793"
        x1="22.0003"
        y1="12.8882"
        x2="17.5695"
        y2="26.6771"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4C0CCF" />
        <stop offset="1" stopColor="#344CEF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_79_793"
        x1="36.5639"
        y1="17.238"
        x2="22.9675"
        y2="32.3661"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#49D7E9" />
        <stop offset="0.456979" stopColor="#71CEF9" />
        <stop offset="1" stopColor="#6EB4FE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_79_793"
        x1="19.5004"
        y1="29.511"
        x2="26.5894"
        y2="35.3388"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#588AFD" />
        <stop offset="0.471686" stopColor="#649EFF" />
        <stop offset="1" stopColor="#6DAFFF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_79_793"
        x1="37.5716"
        y1="37.7446"
        x2="41.4631"
        y2="22.9926"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C8FCC6" />
        <stop offset="0.497488" stopColor="#95F8D2" />
        <stop offset="1" stopColor="#5EF1DA" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_79_793"
        x1="37.7858"
        y1="13.0303"
        x2="33.2613"
        y2="27.7277"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15E6E8" />
        <stop offset="0.433113" stopColor="#36E8E5" />
        <stop offset="1" stopColor="#65E8E2" />
      </linearGradient>
    </defs>
  </svg>
);
